export default "__VITE_ASSET__Da9UDn6U__"